import { Paper, Box } from '@mui/material';
import React, { forwardRef, useCallback } from 'react';
import { searchInputContainerSx } from './styles';

interface CustomPaperProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  inputValue?: string;
  onInputChange?: (value: string) => void;
}

const inputStyles: React.CSSProperties = {
  width: '100%',
  height: '36px',
  padding: '8px 12px',
  fontSize: '14px',
  borderRadius: '4px',
  backgroundColor: '#f5f5f5',
  color: '#666',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
  outline: 'none',
  caretColor: '#000',
  transition: 'all 0.2s ease-in-out',
  border: 'none',
};

export const CustomPaper = forwardRef<HTMLDivElement, CustomPaperProps>(
  ({ children, inputValue = '', onInputChange, ...other }, ref) => {
    const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
      e.currentTarget.style.backgroundColor = '#ffffff';
      e.currentTarget.style.boxShadow = 'inset 0 0 0 1px #1976d2';
    }, []);

    const handleBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
      e.currentTarget.style.backgroundColor = '#f5f5f5';
      e.currentTarget.style.boxShadow = 'none';
    }, []);

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
      onInputChange?.(e.target.value);
    }, [onInputChange]);

    return (
      <Paper ref={ref} {...other}>
        <Box sx={searchInputContainerSx}>
          <input
            type="text"
            placeholder="Search"
            value={inputValue}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            style={inputStyles}
          />
        </Box>
        {children}
      </Paper>
    );
  },
);

CustomPaper.displayName = 'CustomPaper';
